
    import './styles.scoped.css';
    export default {
  "placeholder": "awsui_placeholder_dwuol_agn1m_93",
  "item": "awsui_item_dwuol_agn1m_98",
  "checkbox": "awsui_checkbox_dwuol_agn1m_102",
  "filter": "awsui_filter_dwuol_agn1m_111",
  "trigger": "awsui_trigger_dwuol_agn1m_116",
  "layout-strut": "awsui_layout-strut_dwuol_agn1m_122",
  "list-bottom": "awsui_list-bottom_dwuol_agn1m_128",
  "selected-icon": "awsui_selected-icon_dwuol_agn1m_132",
  "show-label-tag": "awsui_show-label-tag_dwuol_agn1m_136"
};
  